export const dateLong = new Intl.DateTimeFormat('de-DE', {
  weekday: 'short',
  day: '2-digit',
  month: 'long',
  hour: '2-digit',
  minute: '2-digit',
});

export const timeShort = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' });

export function splitDate(iso: string) {
  const d = new Date(iso);
  return {
    day: String(d.getDate()).padStart(2, '0'),
    month: new Intl.DateTimeFormat('de-DE', { month: 'short' }).format(d).replace('.', ''),
    time: timeShort.format(d),
  };
}

export const statusLabel = {
  live: 'Live',
  upcoming: 'Geplant',
  finished: 'Beendet',
} as const;

export const statusTag = {
  live: 'tag tag--live',
  upcoming: 'tag tag--soon',
  finished: 'tag tag--done',
} as const;

/**
 * ISO-Zeitstempel -> Wert fuer <input type="datetime-local">.
 * toISOString() liefert UTC; das Eingabefeld erwartet Ortszeit, sonst
 * verschiebt sich die Startzeit bei jedem Speichern um den Zeitzonen-Versatz.
 */
export function toLocalInput(iso: string | number | Date): string {
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60_000).toISOString().slice(0, 16);
}
